// @flow

type ShowSnackbar = 'bravissimo/snackbar/SHOW_SNACKBAR';
type HideSnackbar = 'bravissimo/snackbar/HIDE_SNACKBAR';
export const SHOW_SNACKBAR: ShowSnackbar = 'bravissimo/snackbar/SHOW_SNACKBAR';
export const HIDE_SNACKBAR: HideSnackbar = 'bravissimo/snackbar/HIDE_SNACKBAR';
